import { UserId } from '@kaizenplatform/kaizen-id-entity';

import HttpClient from '../../adapter/HttpClient';
import ProductPricing from '../../entity/ProductPricing';

class AcctWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public getProductPricing = async (kaizenUserId: UserId): Promise<ProductPricing> => {
    const res = await this.httpClient.get(`/acct/applications/point_product_pricing?organization_id=${kaizenUserId}`);
    if (!res.data.data) {
      throw new ProductPricingNotFound({ id: kaizenUserId });
    }

    return ProductPricing.fromJSON(res.data.data);
  };
}

export class ProductPricingNotFound extends Error {
  public readonly name = 'ProductPricingNotFound';
  public readonly message: string;
  public readonly id: UserId;

  constructor({ id }: { id: UserId }) {
    super();

    this.id = id;
    this.message = `message.get_product_pricing_has_failed`;
  }
}

export default AcctWebApi;
